/**
 * Import required libraries
 */
import React from "react";

/**
 * Import required elements
 */
// Material-ui components
import { Button } from "@material-ui/core";
// Material-ui icons
import {
  Home,
  Phone as ContactIcon,
  ExitToApp as LoginIcon,
  PersonAdd as SignUpIcon
} from "@material-ui/icons";

import styles from "./styles";
import labels from "./labels";

/**
 * MenuList Render JSX
 */
const LandingMenu = props => {
  let { lang, contactPageEnabled, presentationButtonEnabled, updateLandingPage } = props;

  // CSS classnames
  const classes = styles();

  const button = ({Icon, ...p}, i) => (
    <Button key={i.toString()}
      classes={{
        root: p.className || classes.button,
        label: classes.buttonLabel
      }}
      size="small"
      variant={p.variant}
      onClick={p.onClick}
      color={p.color}
      startIcon={<Icon className={classes.icon}/>}
    >
      {p.label}
    </Button>
  );

  let buttons = [{
    className: classes.login,
    variant: "contained",
    onClick: e => updateLandingPage(e, "Login"),
    label: labels.login[lang],
    color: "primary",
    Icon: LoginIcon
  }, {
    className: classes.signup,
    variant: "contained",
    onClick: e => updateLandingPage(e, "SignUp"),
    label: labels.signup[lang],
    color: "secondary",
    Icon: SignUpIcon
  }]
  
  if(contactPageEnabled){
    buttons.push({
      onClick: e => updateLandingPage(e, "Contact"),
      label: "Contact",
      Icon: ContactIcon
    })
  }
  if(presentationButtonEnabled){
    buttons.push( {
      onClick: e => updateLandingPage(e, "Presentation"),
      label: labels.home[lang],
      Icon: Home
    })
  }
  
  return (
    <div className={classes.MenuList}>
      {buttons.map(button)}
    </div>
  );
};

export default LandingMenu;
